/**
 * Sidebar Footer Styled Components
 *
 * @since 1.0.0
 */

import styled from '@emotion/styled';
import { colors } from '@redfoxwp/core-components/colors';

/**
 * Footer Wrapper
 */
export const FooterWrapper = styled.div`
	margin-top: auto;
`;

/**
 * Footer Link
 */
export const FooterLink = styled.a`
	display: flex;
	align-items: center;
	gap: 8px;
	color: ${colors.gray[700]};
	text-decoration: none;
	transition: all 0.2s ease;

	&:hover {
		color: ${colors.primary[300]};
	}

	&:focus {
		outline: none;
		box-shadow: none;
	}

	svg {
		flex-shrink: 0;
	}
`;

